import { render, staticRenderFns } from "./HoldingContract.vue?vue&type=template&id=44859dc6&scoped=true&"
import script from "./HoldingContract.vue?vue&type=script&lang=js&"
export * from "./HoldingContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44859dc6",
  null
  
)

export default component.exports